import React from 'react';
import { Lightbulb, Star, Zap, Heart } from 'lucide-react';
export const ShenSha: React.FC = () => {
  return <div className="space-y-12" data-id="element-306">
      <div className="text-center mb-10" data-id="element-307">
        <h1 className="text-3xl font-serif font-bold text-gold-dark mb-4" data-id="element-308">
          神煞吉凶
        </h1>
        <p className="text-ink-light" data-id="element-309">
          八字中的"特殊星星"，为命局增添传奇色彩的辅助参考。
        </p>
      </div>

      <div className="bg-gold/5 border border-gold/20 p-6 rounded-lg flex gap-4 items-start" data-id="element-310">
        <div className="bg-gold/20 p-2 rounded-full text-gold-dark shrink-0" data-id="element-311">
          <Lightbulb size={24} data-id="element-312" />
        </div>
        <div data-id="element-313">
          <h3 className="font-serif font-bold text-gold-dark text-lg mb-2" data-id="element-314">
            小白理解法：游戏里的Buff
          </h3>
          <p className="text-ink-light text-sm leading-relaxed" data-id="element-315">
            如果五行生克是你的基础属性（攻击力、防御力），那神煞就是你带的被动技能（Buff）。
            <br data-id="element-316" />
            吉神就像增益Buff（如：遇到危险有人救）；凶煞就像减益Buff（如：容易冲动受伤）。
            <br data-id="element-317" />
            <strong data-id="element-318">注意：</strong>
            神煞只是辅助，不能单凭一个神煞就定吉凶，必须结合五行生克来看！
          </p>
        </div>
      </div>

      <section className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-319">
        <div className="bg-white ink-border p-6 rounded-lg shadow-sm" data-id="element-320">
          <div className="flex items-center gap-2 mb-4" data-id="element-321">
            <Star className="text-gold-dark" size={24} data-id="element-322" />
            <h3 className="text-xl font-serif font-bold text-ink" data-id="element-323">天乙贵人</h3>
          </div>
          <div className="text-sm bg-jade/10 text-jade inline-block px-2 py-1 rounded mb-3 font-medium" data-id="element-324">
            最强吉神
          </div>
          <p className="text-ink-light text-sm leading-relaxed" data-id="element-325">
            逢凶化吉的超级贵人星。命带天乙贵人，遇到困难总有人出手相助，一生少病少灾，人缘极佳。
          </p>
        </div>

        <div className="bg-white ink-border p-6 rounded-lg shadow-sm" data-id="element-326">
          <div className="flex items-center gap-2 mb-4" data-id="element-327">
            <Heart className="text-cinnabar" size={24} data-id="element-328" />
            <h3 className="text-xl font-serif font-bold text-ink" data-id="element-329">
              桃花 (咸池)
            </h3>
          </div>
          <div className="text-sm bg-paper-dark text-ink-light inline-block px-2 py-1 rounded mb-3 font-medium" data-id="element-330">
            中性神煞
          </div>
          <p className="text-ink-light text-sm leading-relaxed" data-id="element-331">
            代表魅力、异性缘、艺术才华。桃花旺的人长相出众，容易吸引人。但若桃花为忌，则容易陷入感情纠纷。
          </p>
        </div>

        <div className="bg-white ink-border p-6 rounded-lg shadow-sm" data-id="element-332">
          <div className="flex items-center gap-2 mb-4" data-id="element-333">
            <Zap className="text-ink-light" size={24} data-id="element-334" />
            <h3 className="text-xl font-serif font-bold text-ink" data-id="element-335">羊刃</h3>
          </div>
          <div className="text-sm bg-cinnabar/10 text-cinnabar inline-block px-2 py-1 rounded mb-3 font-medium" data-id="element-336">
            偏凶神煞
          </div>
          <p className="text-ink-light text-sm leading-relaxed" data-id="element-337">
            极度刚强、锐利的星。代表性格刚烈、固执、容易有意外伤害或手术。但若命局身弱，羊刃反而能帮身抗敌。
          </p>
        </div>
      </section>
    </div>;
};